<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
      <i :class="classIcon" v-if="!isIconSvg"></i>
      <span class="nav-icon nav-icon--svg" v-else v-html="icon"></span>
      {{name}}
      <b-badge v-if="badge && badge.text && badge.text != 'private'" :variant="badge.variant">{{badge.text}}</b-badge>
    </div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    classIcon () {
      return [
        'nav-icon',
        this.icon
      ]
    },
    isIconSvg () {
      return this.icon.startsWith('<svg')
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style scoped lang="css">
  .nav-link {
    cursor:pointer;
  }
  .nav-icon--svg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    line-height: 1;
    vertical-align: middle;
  }
  .nav-icon--svg svg {
    width: 14px;
    height: 14px;
  }
</style>
